import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import CardWidget, { Colors } from '../../../components/CardWidget'
import CardWidgetSkeleton from '../../../components/skeletons/CardWidgetSkeleton'
import { formatNumber } from '../../../utils/Helpers'
import { EventsFiltersContext } from '../../../context/EventsFiltersContext'
import { GET_QUANTITY_OFFERS_RECEIVED } from '../../../queries/events'

const QuantityReceived = (): JSX.Element => {
  const { filters } = useContext(EventsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_QUANTITY_OFFERS_RECEIVED, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters: { ...filters } }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  return (
    <CardWidget title="Ofertas Recebidas pelo serviço de validação" number={formatNumber(data.eventOfferIntegrationValidatorAggs.aggregations.totals.value)} color={Colors.blue} />
  )
}

export default QuantityReceived
